import { Typography, Grid, Box, useTheme } from "@mui/material"
import ContainedButton from "../../actions/ContainedButton"
import SvgColor from "../../svg-color"


const SuccessView = ({
    loading, 
    onSubmit
}) => {


    const mobileContent = (
        <div >
            <Typography variant='h4' align='center' style={{fontWeight:600}}>
                ¡Felicidades!
            </Typography>
            <div style={{textAlign:'center', paddingBottom:16}}>
                <Grid container justifyContent='center'>
                    <Grid item>
                        <Box sx={{
                           width:100,
                           height:100,
                           borderRadius:'50%',
                           border:'1px solid white',
                           background:(theme) =>theme.palette.primary.light,
                           position:'relative' ,
                           my:3,
                        }}>
                            <Box sx={{
                                position:'absolute',
                                top:'50%', left:'50%',
                                transform:'translate(-50%, -50%)',
                            }}>
                                <SvgColor 
                                src="/assets/images/icons/check.svg"
                                color={theme => theme.palette.primary.main} 
                                sx={{width:48, height:48}}/>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
                <Typography style={{fontSize:'1.250rem'}}>
                    Tu contraseña ha sido actualizada correctamente!
                </Typography>

            </div>
            <ContainedButton 
                fullWidth
                loading={loading}
                onClick={onSubmit}
            >Iniciar sesión</ContainedButton>
        </div>
    )


    return(
        <div>
            {mobileContent}
        </div>
    )
}

export default SuccessView